module.exports = __webpack_public_path__ + "static/media/icons.d41944d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icons.svg
// module id = 292
// module chunks = 0